import * as React from "react";
import {sendRequest} from "../../helpers/ajax";
import IEmailRegistrationRequest from "../../types/IEmailRegistrationRequest";
import IEmailRegistrationResponse from "../../types/IEmailRegistrationResponse";
import IResponse from "../../types/IResponse";
import RegisterRequest from "./RegisterRequest";

class RegisterRequestContainer extends React.Component{

    constructor(props: any) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public render() {
        return (
            <RegisterRequest 
                onSubmit={this.onSubmit} 
            />
        );
    }

    private async onSubmit(email: string): Promise<boolean> {
        const request: IEmailRegistrationRequest = { email };
        const response = await sendRequest<IResponse<IEmailRegistrationResponse>>("/api/Register/EmailRegistration", "POST", request);

        if (response && response.success && response.payload.success) {
            return true;
        } else {
            return false;
        }
    }
}

export default RegisterRequestContainer;



// WEBPACK FOOTER //
// ./src/components/RegisterRequest/RegisterRequestContainer.tsx